import { CartographyResource } from './cartography-resource';
import { CartographyResourceBbxStatusEnum } from '../../enum/cartography-resource-bbx-status.enum';
import { CustomLogger } from '../../engine/log/custom-logger';
import { CartographyResourceInfosPositionBbx } from '../cartography-resource-infos/cartography-resource-infos-position/cartography-resource-infos-position-bbx';
import { CartographyResourceInfosStatusBbx } from '../cartography-resource-infos/cartography-resource-infos-status-bbx';
import dayjs from 'dayjs';
import { GmapsMarker } from '@infodata-group/inf-commons-tools';
import { UserSettings } from '../../engine/user-settings';
import { signal, WritableSignal } from '@angular/core';
import { MarkerContentGenerator } from '../../engine/marker-content-generator';

export class CartographyResourceBbx extends CartographyResource {
  public labelBbx: string;
  public idDriver: string;
  public labelDriver: string;
  public kilometers: number;
  public speed: number;
  public materials: unknown[];
  public cap: number;

  public override options: google.maps.MarkerOptions = {
    icon: this.getIconMarker(),
    zIndex: 100,
  };

  public updatedStatusAt: Date;

  public status: CartographyResourceBbxStatusEnum =
    CartographyResourceBbxStatusEnum.Unknow;

  public content: WritableSignal<HTMLDivElement> = signal(null);

  public override getLabel(): string {
    return this.label;
  }

  public override get labelTab(): string {
    return `${this.labelDriver} - ${this.labelBbx}`;
  }

  public override updatePosition(
    position: CartographyResourceInfosPositionBbx,
  ) {
    super.updatePosition(position);
    if (!this.checkPosition(position)) {
      return;
    }
    this.address = position.address;
    this.kilometers = position.kilometers;
    this.speed = position.speed;
    this.materials = position.materials;
    this.cap = position.cap;
    if (!this.isValidLatLng()) {
      this.check = false;
    }
    this.updateContent();
  }

  updateStatus(status: CartographyResourceInfosStatusBbx): void {
    if (status.idResource !== this.getId()) {
      CustomLogger.e({
        message: `Wrong item '${this.getId()}' to update status`,
      });
      return;
    }
    this.status = status.status;
    switch (status.status) {
      case CartographyResourceBbxStatusEnum.Stop:
        this.iconColor = '#ed5565';
        break;
      case CartographyResourceBbxStatusEnum.Driving:
        this.iconColor = '#48cfad';
        break;
      case CartographyResourceBbxStatusEnum.Uncertain:
        this.iconColor = '#F6BB42';
        break;
      default:
        this.iconColor = '#2f373a';
    }
    this.updatedStatusAt = new Date();
    this.options = { ...this.options, ...{ icon: this.getIconMarker() } };
    this.updateContent();
  }

  public getIconMarker(size?: number): string {
    const icon = this.icon ? this.icon : 'car';
    if (!size) {
      size = UserSettings.markerSize;
    }

    const color = this.status ?? 3;
    return `assets/img/google-map/markers/bbx/${icon}-size${size}-color${color}.svg`;
  }

  public override matchFilter(field: string, value: string): boolean {
    // Case "Active today"
    if (value === '9999') {
      return this.date >= dayjs().startOf('day').toDate();
    }
    return super.matchFilter(field, value);
  }

  public toMarker(): GmapsMarker {
    const marker = new GmapsMarker(this.id, this.latitude, this.longitude);
    marker.options = this.options;
    return marker;
  }

  public updateContent(): void {
    this.eventListeners.forEach((eventListener, i) => {
      this.content().removeEventListener(
        eventListener.type,
        eventListener.listener,
      );
    });
    this.eventListeners = [];
    this.content.set(
      MarkerContentGenerator.generateMarkerContent({
        label: [this.labelDriver],
        icon: this.icon,
        color: this.iconColor,
        resource: this,
      }),
    );
  }
}
